module.exports = __webpack_public_path__ + "static/media/AndGoPaperless_animation.c8ea4aaa.gif";